import script from "./ExpertDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpertDetail.vue?vue&type=script&setup=true&lang=js"

import "./ExpertDetail.vue?vue&type=style&index=0&id=a6567eb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6567eb2"]])

export default __exports__